import React, { useState, useReducer } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import DialogActions from "@mui/material/DialogActions";
import dayjs from "dayjs";
import AccountNumberStep from "./AccountNumberStep";
import { get } from "aws-amplify/api";
import { I18n } from "aws-amplify/utils";
import currentUserToken from "CurrentUserToken";
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';

const reducer = (lastState, action) => {
  if (action.type === "DATA_RECEIVED") {
    const audit = action.value;
    if (Array.isArray(audit)) {
      audit.forEach((element) => {
        if (typeof element.timestamp === "number") {
          element.timestamp = dayjs(element.timestamp).format(
            "YYYY-MM-DD HH:mm"
          );
        }
      });
      return { audit: audit, fetched: true };
    }
  }
  return lastState;
};

function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

function AccountListPopup(props) {
  const [state, dispatch] = useReducer(reducer, {
    audit: [],
    fetched: false,
  });
  const [selectedAccountNumber, setSelectedAccountNumber] = useState(null);
  const [formData, setFormData] = useState({
    account_number: "",
  });

  const fetchAccountNumbers = async () => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/accountNumber/get",
        options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();
      dispatch({ type: "DATA_RECEIVED", value: response });
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleSaveAccountNumber = () => {
    props.handleSaveAccountNumber(selectedAccountNumber);
  };

  const handleMainFormData = (field, value) => {
    setFormData((currentState) => ({
      ...currentState,
      [field]: value,
    }));
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => {
        props.onClose();
      }}
      maxWidth="xl"
      fullWidth
      PaperComponent={PaperComponent}
    >
      <DialogTitle style={{cursor: 'move'}}>{I18n.get("Select Store")}</DialogTitle>
      <DialogContent>
        <AccountNumberStep
          fetchData={fetchAccountNumbers}
          handleMainFormData={handleMainFormData}
          state={state}
          selectedAccountNumber={selectedAccountNumber}
          setSelectedAccountNumber={setSelectedAccountNumber}
          mainFormData={formData}
        />
      </DialogContent>
      <DialogActions sx={{ pt: 2 }} style={{cursor: 'move'}}>
        <Box>
          <Button
            onClick={() => props.onClose()}
            style={{ marginLeft: "10px", color: (!formData.account_number ||
              formData.account_number === null) ? "gray" : "red" }}
          >
            {I18n.get("Cancel")}
          </Button>
          <Button
            color="primary"
            onClick={handleSaveAccountNumber}  
            disabled={
              !formData.account_number ||
              formData.account_number === null
            }
          >
            {I18n.get("Submit")}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}

export default AccountListPopup;
